export default __webpack_public_path__ + "static/media/convocatorialeon.31cf5318.pdf";